import { useScrollReveal } from '@/hooks/useScrollReveal';

const departments = [
  {
    icon: 'ri-building-4-line',
    name: 'Storage Partnerships',
    description:
      'Join 340+ warehouses on our network. Talk to our storage team about onboarding your facility, capacity mapping, and earning through our platform.',
    email: 'storage@freshhlock.com',
    accentClass: 'bg-primary-100 text-primary-700',
    iconBgClass: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-truck-line',
    name: 'Transport Partnerships',
    description:
      'Access 2,500+ vehicles and route-matching algorithms. Reach our fleet team to discuss partnership, compliance, and real-time load booking.',
    email: 'transport@freshhlock.com',
    accentClass: 'bg-secondary-100 text-secondary-700',
    iconBgClass: 'bg-secondary-100 text-secondary-600',
  },
  {
    icon: 'ri-shopping-bag-3-line',
    name: 'Wholesale Trade Desk',
    description:
      'For bulk buyers and suppliers: verified SKUs, transparent pricing, quality assurance. Our trade team handles onboarding, disputes, and category requests.',
    email: 'wholesale@freshhlock.com',
    accentClass: 'bg-accent-100 text-accent-700',
    iconBgClass: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-store-2-line',
    name: 'Retail & Consumer Support',
    description:
      'Questions about your order, delivery, or the Freshhlock retail experience? Our consumer team is here for you — 6 days a week, 8 AM to 10 PM.',
    email: 'retail@freshhlock.com',
    accentClass: 'bg-foreground-100 text-foreground-700',
    iconBgClass: 'bg-foreground-100 text-foreground-600',
  },
];

export default function DepartmentCardsSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section id="departments" className="py-16 md:py-20 bg-background-50">
      <div
        ref={ref}
        className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}
      >
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-semibold uppercase tracking-widest text-primary-600 bg-primary-100 rounded-full mb-4">
            Our Teams
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Talk to the Right Team
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            Every department has specialists who understand your needs. Reach out
            directly and skip the routing queue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {departments.map((dept) => (
            <div
              key={dept.name}
              className="group bg-card-50 rounded-xl p-6 md:p-8 border border-card-200 shadow-sm hover:shadow-md hover:border-primary-200/60 transition-all cursor-default card-animate"
            >
              <div className="flex items-start gap-5">
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-lg shrink-0 ${dept.iconBgClass} animate-icon-float icon-hover-pop`}
                >
                  <i className={`${dept.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                    {dept.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                    {dept.description}
                  </p>

                  <div className="space-y-2.5">
                    <a
                      href={`mailto:${dept.email}`}
                      className="flex items-center gap-2.5 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer group/link"
                    >
                      <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-100 group-hover/link:bg-primary-200 transition-colors">
                        <i className="ri-mail-line text-xs"></i>
                      </div>
                      <span className="truncate">{dept.email}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}